import { IMaintenanceError } from 'core/model/interfaces/error.interface';
import type { TSliceReducer } from 'core/store';
import { ILayoutState } from './types';

export const toogleCart: TSliceReducer<ILayoutState, boolean> = (state, action) => ({
  ...state,
  cart: action.payload,
});

export const toogleMenu: TSliceReducer<ILayoutState, boolean> = (state, action) => ({
  ...state,
  menu: action.payload,
});

export const setSearchQuery: TSliceReducer<ILayoutState, string> = (state, action) => ({
  ...state,
  search: action.payload,
});

export const setNotFound: TSliceReducer<ILayoutState, boolean> = (state, action) => ({
  ...state,
  isNotFound: action.payload,
});

export const toogleAddressModal: TSliceReducer<ILayoutState, boolean> = (state, action) => ({
  ...state,
  isAddressModalOpen: action.payload,
});

export const setMaintenanceError: TSliceReducer<ILayoutState, IMaintenanceError['error'] | null> = (state, action) => ({
  ...state,
  maintenanceError: action.payload,
});

export const setNotifiedProducts: TSliceReducer<ILayoutState, string> = (state, action) => ({
  ...state,
  notifiedProducts: {
    ...state.notifiedProducts,
    [action.payload]: (state.notifiedProducts[action.payload] ?? 0) + 1,
  },
});

export const reducers = {
  toogleCart,
  toogleMenu,
  setSearchQuery,
  setNotFound,
  toogleAddressModal,
  setMaintenanceError,
  setNotifiedProducts,
};
